import React from 'react';
import { useTranslation } from 'react-i18next';
import SuccessIcon from '../Icons/SuccessIcon';

interface Props {
  toggleOut(): void;
  toggle(): void;
}

const IncludeOnePersonSuccessModal: React.FC<Props> = ({ toggle, toggleOut }) => {
  const { t } = useTranslation(['includeTeam']);

  return (
    <div className="success-wrapper" data-testid="include-one-success">
      <div className="icon-wrapper">
        <SuccessIcon />
      </div>
      <span className="title-success">{t('success_include')}</span>
      <span className="subtitle">{t('check_list')}</span>
      <button type="button" className="ok-button" onClick={toggleOut}>
        {t('include_another')}
      </button>
      <span className="underlined-back" onClick={toggle}>
        {t('go_back')}
      </span>
    </div>
  );
};

export default IncludeOnePersonSuccessModal;
